module.exports = __webpack_public_path__ + "static/img/2.62f5e53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/2.png
// module id = YcXB
// module chunks = 0